module.exports = __webpack_public_path__ + "img/diners-club@2x.c230f316.png";